import React from 'react';
import { Gift } from 'lucide-react';

interface RewardIconProps {
  isCurrent: boolean;
  isPast: boolean;
}

// Every reward is a gift, so the `--gift-` class segment is fixed. It used to be
// interpolated from `reward.type` to pick up `--discount-`/`--combo-` styling,
// both of which are gone along with the reward types themselves.
export const RewardIcon: React.FC<RewardIconProps> = ({ isCurrent, isPast }) => {
  const state = isCurrent ? 'current' : isPast ? 'past' : 'future';

  return (
    <div
      className={`subscription-timeline__reward-icon subscription-timeline__reward-icon--gift-${state}`}>
      <Gift strokeWidth={2.5} />
      {isPast && (
        <div className="subscription-timeline__check-badge">
          <img src="/media/svg/general/checkmark-2025.svg" alt="completed" />
        </div>
      )}
    </div>
  );
};
